import {search, elasticDelete} from '@/mixins/elastic/elasticsearch.js'

export default {
    data() {
        return {
            ElasticQuery: '',
            ElasticIndexName: '',
            ElasticPage: 0,
            ElasticSearch : null,
            ElasticSubBody: {},
            tableLoading: true,
            ApiData : [],
            pageRow: 10,
            pageRows: [10, 30, 50, 100],
            page : 1,
            searchFilter: [],
            searchValue: [],
            TotalCount: 0,
            TotalPages: 0,
            ListSortValue: {
                name: 'created_at',
                value: 'desc'
            },
            sort : '',
            order : '',
            tableoption: true,
            selectRow: [],
        }
    },
    methods: {
        getTotalSearchValue() {
            return {
                searchValue : this.searchValue,
                page: this.page,
                pageRow: this.pageRow,
                ListSortValue: this.ListSortValue
            };
        },
        runElastic(index, type, func = null, hasPage=true) {
            let body = {
                from : 0,
                size: 10,
                "sort" : [
                    {"i_price" : "desc"},
                    {"created_at" : "desc"},
                ],
                query: {
                    bool: {
                        must: [
                            {match : {"i_is_delete" : 0}},
                            //{terms: {"category.level4": [537, 646, 814, 1409, 538, 647, 815, 1410, 540, 649, 821, 1408, 650, 1407, 651, 652, 816, 1334, 653, 817, 541, 654, 542, 655, 819, 543, 656, 818]}},
                            // {terms: {"i_model": ['CU000688', 'QI000058']}},
                            // {terms: {"i_gender": [0]}},
                            // {simple_query_string: {query: `("요시다포터")`, fields: ["i_name", "category.level4", "i_model"]}}
                            // {simple_query_string: {query: `("EC000229")`, fields: ["i_model"]}}
                            // {simple_query_string: {query: `("[노이어] [Hand Made] 수리알파카 머플러 코트 (애쉬베이지)")`, fields: ["i_name"]}}
                        ]
                    }
                },
               /* "collapse" : {
                    "field" : "i_price"
                },*/
                "aggregations": {
                    "data": {
                        "terms": {
                            "field": "i_price",
                            "min_doc_count": 1,
                            "order": [
                                {
                                    "_key": "asc"
                                }
                            ]
                        },
                        "aggs": {
                            "data": {
                                "terms": {
                                    "field": "i_price"
                                },
                                "aggs": {
                                    "paging": {
                                        "bucket_sort": {
                                            "from": 0,
                                            "size": 20
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                /*"collapse" : {
                    "field" : "i_name.keyword"
                },*/

            }
            if(hasPage) {
                this.setElaPagination();
            }
            // this.ElasticSubBody.aggs = {
            //     "dedup" : {
            //         "terms":{
            //             "field": "i_idx"
            //         },
            //         "aggs":{
            //             "dedup_docs":{
            //                 "top_hits":{
            //                     "size":0
            //                 }
            //             }
            //         }
            //     }
            // }
            // search(index, type, this.ElasticSubBody).then((resp) => {
            search(index, type, body).then((resp) => {
                let list = [];
                if(resp.hasOwnProperty('hits')) {
                    this.TotalCount = resp.hits.total.value;
                    resp.hits.hits.forEach(data => {
                        data._source._id = data._id;
                        list.push(data._source);
                    })
                    this.ApiData = list;

                }
                if(func) {
                    func();
                }else{
                    this.tableLoading = false;
                }
            })
        },
        setPageRow(row) {
            this.setPage(0);
            this.pageRow = row;
        },
        setPage(page = '',type='') {
            this.page = page;
        },
        //modelname 다수일경우 | 기준으로 1번째 value, 2번째 name,
        setFilter(modelname, name, value, type ='match', bool = 'must', func = null) {
            // console.log(`${modelname} / ${name} / ${value} / ${type} / ${bool}`)
            let index = $.inArray(modelname, this.searchFilter);
            if(index > -1) {
                this.searchValue[index].modelname = modelname;
                this.searchValue[index].name = name;
                this.searchValue[index].value = value;
                this.searchValue[index].type = type;
            } else {
                let index = this.searchFilter.length;
                this.searchFilter[index] = modelname;
                this.searchValue[index] = {};
                this.searchValue[index].modelname = modelname;
                this.searchValue[index].name = name;
                this.searchValue[index].type = type;
                this.searchValue[index].value = value;
                this.searchValue[index].bool = bool;
                this.searchValue[index].func = func;
            }
            this.SetElaQuery();
        },
        ReformQuery(sv) {
            let filterWrap = {};
            let name = sv.name;
            if(sv.type === 'match') {
                filterWrap.match = {};
                // filterWrap.terms[name] = sv.value;
                filterWrap.match[name] = sv.value;
            }else if(sv.type === 'range') {
                filterWrap = {
                    'range' : {}
                };
                filterWrap.range[name] = {};
                if(sv.value[0] !== '' && sv.value[0] != null) {
                    filterWrap.range[name]['gte'] = sv.value[0];
                }
                if(sv.value[1] !== '' && sv.value[1] != null) {
                    filterWrap.range[name]['lte'] = sv.value[1];
                }
            }else if(sv.type === 'terms') {
                filterWrap.terms = {};
                filterWrap.terms[name] = sv.value;
            }else if(sv.type === 'query_string') {
                filterWrap = {
                    //   "query_string" : {
                    //     // "query" : `(*${sv.value}*) OR (${sv.value})`,
                    // 	"query" : `"${sv.value}"`,
                    // 	// "query" :
                    //     "default_field" : name
                    //   }
                    "simple_query_string" : {
                        "query" : `("${sv.value}")`,
                        "fields" : [name]
                    }
                }
            }
            return filterWrap;
        },
        RecursiveQueryWrap(searchValue, idx, query) {
            if(idx >= searchValue.length) {
                return query;
            }
            let sv = searchValue[idx];
            if((sv.value === '' || sv.value === null) || (sv.value.length == 2 && sv.value[0] === '' && sv.value === '')){
                return this.RecursiveQueryWrap(searchValue, idx+1, query);
            }
            if(!query.hasOwnProperty('bool')){
                query.bool = {};
            }
            if(!query.bool.hasOwnProperty(sv.bool)){
                query.bool[sv.bool] = [];
            }
            let filterWrap = sv.func ? sv.func() : this.ReformQuery(sv);
            query.bool[sv.bool].push(filterWrap);
            return this.RecursiveQueryWrap(searchValue, idx+1, query);
        },
        SetElaQuery() {
            let ElaQuery = this.RecursiveQueryWrap(this.searchValue, 0, {});
            if(Object.keys(ElaQuery).length === 0) {
                this.ElasticSubBody.query = {"match_all" : {}};
            }else{
                this.ElasticSubBody.query = ElaQuery;
            }
        },

        setElaPagination() {
            this.ElasticSubBody.from = (Number(this.page) - 1) * this.pageRow;
            this.ElasticSubBody.size = this.pageRow;
        },

        setElaSort(name, value) {
            if(!name) {
                name = 'created_at'
            }
            if(value) {
                value = 'desc'
            }
            let sortWrap = [{}];
            sortWrap[0][name] = value;
            this.ElasticSubBody.sort = sortWrap;
        },
        setSort(name, value) {
            this.setPage(1);
            this.ListSortValue.name = name;
            this.ListSortValue.value = value;
            this.setElaSort(name, value);
        },
        orderName(orderName) {
            return orderName === 'asc' || orderName === 'ascending' ? 'ascending' : orderName === 'desc' || orderName === 'descending' ? 'descending' : null;
        },
        cellClick(row, column, cell) { //만약 필요하면 가져가서 커스텀하기

        },
        tableIndex(index) {
            return this.TotalCount - index - (this.page - 1) * this.pageRow;
        },
        tableSelectChnage(row) {
            this.selectRow = row;
        },
        FilterDelete(name) {
            let index = $.inArray(name, this.searchFilter);
            if(index > 0) {
                this.searchValue.splice(index, 1);
                this.searchFilter.splice(index, 1);
            }
        },

        sortChange({ column, prop, order }) {
            this.page = 1;
            let sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : "";
            let sortProp = column.sortProp;
            if(order === null) {
                sortOrder = 'desc';
                sortProp = 'created_at';
            }
            this.setSort(sortProp, sortOrder);
            this.getList();
        },

        pageChange(page) {
            this.getList();
        },

        runDeleteFunc(index, type, id) {
            elasticDelete(index, type, id);
        },
    },
    computed: {
        ListData() {
            return this.ApiData
        },
        Listlength() {
            return this.ApiData.length;
        }
    }
}
